import React from 'react';

const CrossIcon = ({ color = "#000" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
            <path d="M12.75 4.75L4.25 13.25" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.25 4.75L12.75 13.25" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

export default CrossIcon;